const messagesDe = {
  about: 'Über',
  acceptanceCriteria: 'Akzeptanzkriterien',
  accomplishments: 'Errungenschaften',
  actions: 'Aktionen',
  activity: 'Aktivität',
  activatePod: 'POD aktivieren',
  activePods: 'Aktive PODs',
  add: 'Hinzufügen',
  addBlocker: 'Blocker-Information hinzufügen',
  addingCandidateWait: 'Kandidat wird hinzugefügt, bitte warten...',
  addPortfolio: 'Portfolio hinzufügen',
  addStakeholder: 'Stakeholder hinzufügen',
  addVideoUpdate: 'Video-Update hinzufügen',
  findAgents: 'Agenten finden',
  all: 'Alle',
  allReporters: 'Alle Reporter',
  allRepoCheckins: 'Alle Repo-Check-ins',
  approve: 'Genehmigen',
  approved: 'Genehmigt',
  approvalRequests: 'Genehmigungsanfragen',
  approvedPRCount: 'Anzahl genehmigter PRs',
  assignedItems: 'Zugewiesene Elemente',
  availability: 'Verfügbarkeit',
  availableDate: 'Verfügbares Datum',
  backToPods: 'Zurück zu meinen PODs',
  basicInformation: 'Grundinformationen',
  blocker: 'Blocker',
  blockerDetails: 'Blocker-Details',
  blockers: 'Blocker',
  board: 'Board',
  browseTalent: 'Talente durchsuchen',
  bugs: 'Bugs',
  calendlyUrl: 'Calendly-URL',
  cancel: 'Abbrechen',
  candidates: 'Kandidaten',
  categories: 'Kategorien',
  certifications: 'Zertifizierungen',
  certificationUrl: 'Zertifizierungs-URL',
  checkBoxBlocker: 'Aktivieren Sie dieses Kästchen, wenn es ein Blocker ist',
  ciCdPipeline: 'CI/CD-Pipeline',
  clear: 'Löschen',
  client: 'Kunde',
  clickHereUploadVideoClip: 'Klicken Sie hier, um einen Videoclip hochzuladen!',
  cloudCost: 'Cloud-Kosten',
  code: 'Codezeilen',
  codeSmells: 'Code-Smells',
  commentHere: 'hier kommentieren...',
  category: 'Kategorie',
  comments: 'Kommentare',
  companyName: 'Firmenname',
  copied: 'Kopiert!',
  copyright: 'Copyright © 2025-heute Brilli Global, Inc. Alle Rechte vorbehalten.',
  copyToClipboard: 'In Zwischenablage kopieren',
  cost: 'Kosten',
  costDetails: 'Kostendetails',
  country: 'Land',
  create: 'Erstellen',
  createArt: 'ART erstellen',
  createGig: 'Lösung erstellen',
  createPod: 'POD erstellen',
  createProfile: 'Profil erstellen',
  createProfileOpportunity: 'Erstellen Sie Ihr Profil in unserer Talentdatenbank, um bei verschiedenen Remote-Work-Möglichkeiten berücksichtigt zu werden.',
  createTask: 'Aufgabe erstellen',
  createYourOwnPod: 'Erstellen Sie Ihren eigenen POD und durchsuchen Sie Projekte',
  creatingProfile: 'Profil wird erstellt',
  currency: 'Währung',
  currentlyAvailable: 'Derzeit verfügbar',
  currentWeek: 'Aktuelle Woche',
  dashboard: 'Dashboard',
  date: 'Datum',
  dateRangeFilter: 'Datumsbereichsfilter',
  deactivatePod: 'POD deaktivieren',
  deactivateToUpdate: 'Deaktivieren Sie den POD, um den POD zu aktualisieren!',
  defects: 'Defekte',
  delete: 'Löschen',
  deletePod: 'POD löschen',
  description: 'Beschreibung',
  detailsForGitHubRepo: 'Details für GitHub-Repository',
  done: 'schließen',
  Done: 'ERLEDIGT',
  doraMetrics: 'Dora-Metriken',
  dueDate: 'Fälligkeitsdatum',
  duplicatedLinesDensity: 'Dichte doppelter Zeilen',
  edit: 'Bearbeiten',
  education: 'Bildung',
  educationAndCertifications: 'Bildung und Zertifizierungen',
  email: 'E-Mail',
  podTime: 'POD-Zeit',
  createHub: 'Hub erstellen',
  createSolution: 'Lösung erstellen',
  podVelocity: 'POD-Geschwindigkeit',
  podBlockers: 'POD-Blocker',
  podsync: 'POD-Synchronisation',
  endDate: 'Enddatum',
  enterEmailToInvite: 'E-Mail zum Einladen eingeben',
  enterPodMission: 'POD-Mission eingeben',
  enterPodName: 'POD-Name eingeben',
  enterStoryDescription: 'Story-Beschreibung eingeben',
  executionDate: 'Ausführungsdatum',
  executionID: 'Ausführungs-ID',
  externalPod: 'Externer POD',
  fileNameNoSpaces: 'Der Dateiname sollte keine Leerzeichen zwischen allen Elementen oder Zeichen enthalten',
  fileUpload: 'Datei-Upload',
  findBestFreelancers: 'Finden Sie die besten Freelancer oder Talent-PODs, um Ihre Projekte schneller zu liefern!',
  findBestPod: 'Finden Sie PODs, die zu Ihrer Erfahrung/Ihrem Skillset passen',
  findPods: 'PODs finden',
  findTalent: 'Talente finden',
  findYourBestTalentPod: 'Finden Sie Ihren besten Talent-POD',
  firstName: 'Vorname',
  focus: 'Fokus',
  gitHubRepo: 'GitHub-Repository',
  gitHubUsername: 'GitHub-Benutzername',
  github: 'Github',
  githubSummary: 'GitHub-Zusammenfassung',
  githubUrl: 'Github-URL',
  githubUser: 'GitHub-Benutzer',
  giveRating: 'Bewertung abgeben',
  globalWorkPlatform: 'Globale Arbeitsplattform',
  home: 'Startseite',
  hoursPerWeek: 'Stunden pro Woche',
  inactivePod: 'Inaktiver POD',
  individual: 'Individuell',
  industry: 'Branche',
  inProgress: 'IN BEARBEITUNG',
  institute: 'Institut',
  internalPod: 'Interner POD',
  invite: 'Einladen',
  invoices: 'Rechnungen',
  issueKey: 'Issue-Schlüssel',
  issueStatus: 'Issue-Status',
  issueSummary: 'Issue-Zusammenfassung',
  jiraIssue: 'Jira-Issue',
  jiraIssues: 'Jira-Issues',
  jiraItem: 'Jira-Element',
  jiraTimeDetails: 'Zeitprotokoll',
  jiraUsername: 'Jira-Benutzername',
  keepDoing: 'Weitermachen',
  keyword: 'Stichwort',
  languageSpoken: 'Gesprochene Sprache',
  lastName: 'Nachname',
  latestSprintVelocity: 'Neueste Sprint-Geschwindigkeit',
  linkedIn: 'LinkedIn',
  linkedInUrl: 'LinkedIn-URL',
  linesOfCodeByDay: 'Codezeilen pro Tag',
  listOfTalents: 'Liste der Talente',
  loading: 'Wird geladen',
  loadingAcceptanceCriteria: 'Akzeptanzkriterien werden geladen',
  loadingStoryDescription: 'Story-Beschreibung wird geladen',
  loadingTestCases: 'Testfälle werden geladen',
  logOut: 'Abmelden',
  login: 'Anmelden',
  manage: 'Verwalten',
  manageActivities: 'Verwalten Sie Ihre täglichen POD-Aktivitäten und Updates',
  manageProfile: 'Profil verwalten',
  manageProfileHere: 'Verwalten Sie Ihr Profil hier',
  managePod: 'POD verwalten',
  managePods: 'Verwalten Sie alle Ihre PODs und deren Aktivitäten',
  markComplete: 'Als abgeschlossen markieren',
  middleName: 'Zweitname',
  myPods: 'Meine PODs',
  myTasks: 'Meine Aufgaben',
  name: 'Name',
  ncloc: 'Ncloc',
  newActivityUpdate: 'Neues Aktivitäts-Update',
  next: 'Weiter',
  noArtOptionsAvailable: 'Keine ART-Optionen verfügbar',
  noBlockers: 'Es gibt keine Blocker',
  noCandidates: 'Keine Kandidaten hinzugefügt',
  noCandidatesAddedToPod: 'Keine Kandidaten zum POD hinzugefügt!',
  noCandidateReviews: 'Es gibt keine Kandidatenbewertungen.',
  noData: 'Keine Daten',
  noDataAvailable: 'Keine Daten verfügbar',
  noExperience: 'Keine Erfahrung',
  noMatchingPods: 'Es sind keine passenden PODs verfügbar',
  noNotifications: 'Es gibt keine Benachrichtigungen',
  noPodActivity: 'Sie haben keine POD-Aktivität',
  noPods: 'Sie haben keinen POD',
  noPodTasks: 'Sie haben keine POD-Aufgaben',
  noReviews: 'Es gibt keine Bewertungen.',
  noStakeholders: 'Es gibt keine Stakeholder für diesen POD',
  noSubscription: 'Sie haben kein Abonnement',
  noVideoAvailable: 'Kein Video verfügbar',
  notifications: 'Benachrichtigungsempfänger',
  otherInformation: 'Weitere Informationen',
  pending: 'Ausstehend',
  pendingPods: 'Ausstehende PODs',
  phoneNumber: 'Telefonnummer',
  pipelineExecutionDetails: 'Pipeline-Ausführungsdetails',
  pipelineName: 'Pipeline-Name',
  pipelineVersion: 'Pipeline-Version',
  pleaseEnterStoryDescription: 'Bitte geben Sie eine Story-Beschreibung ein und klicken Sie auf Senden',
  POD: 'POD',
  podActivities: 'POD-Aktivitäten',
  podActivity: 'POD-Aktivität',
  podAnalytics: 'POD-Analytik',
  podAssist: 'POD-Assistent',
  podAutomation: 'POD-Automatisierung',
  podBoard: 'POD-Board',
  podCategories: 'POD-Kategorien',
  podDescription: 'POD-Beschreibung',
  podExperience: 'POD-Erfahrung',
  podFeedback: 'POD-Feedback',
  podMetrics: 'POD-Metriken',
  podName: 'POD-Name',
  podQuery: 'POD-Abfrage',
  podRequests: 'POD-ANFRAGEN',
  podRetro: 'POD-Retro',
  podSize: 'POD-Größe',
  podTasks: 'POD-Aufgaben',
  podTaskDescription: 'POD-Aufgabenbeschreibung',
  podTaskDueDate: 'POD-Aufgabenfälligkeitsdatum',
  podTaskName: 'POD-Aufgabenname',
  podTaskOwner: 'POD-Aufgabenbesitzer',
  podTaskStatus: 'POD-Aufgabenstatus',
  podTechStack: 'POD-Tech-Stack',
  podTeamMember: 'POD-Teammitglied',
  podType: 'POD-Typ',
  portfolio: 'Portfolio',
  portfolioUrl: 'Portfolio-URL',
  post: 'Posten',
  postActivity: 'Aktivität posten',
  postPodActivity: 'POD-Aktivität posten',
  postRequirement: 'Anforderung posten',
  posting: 'Wird gepostet...',
  postedDate: 'Gepostetes Datum',
  postedRequirements: 'Ihre geposteten POD-Anforderungen',
  positionName: 'Positionsname',
  prCount: 'PR-Anzahl',
  preferredWorkHours: 'Bevorzugte Arbeitszeiten',
  prev: 'Zurück',
  previousPods: 'Vorherige PODs',
  previousWeek: 'Vorherige Woche',
  primarySkill: 'Hauptfertigkeit',
  privacyPolicy: 'Datenschutzrichtlinie',
  privatePods: 'Private PODs',
  prSummary: 'PR-Zusammenfassung',
  projectKey: 'Projektschlüssel',
  profileLink: 'Profil-Link',
  profileVisibility: 'Profilsichtbarkeit',
  public: 'Öffentlich',
  qualification: 'Qualifikation',
  ratePerHour: 'Stundensatz',
  ratePerMonth: 'Monatssatz',
  recentSearches: 'Letzte Suchen',
  region: 'Region',
  register: 'Registrieren',
  resetPassword: 'Passwort zurücksetzen',
  restricted: 'Eingeschränkt',
  retro: 'Retro',
  review: 'Bewertung und Rating',
  revisionSummary: 'Revisionszusammenfassung',
  revisionURL: 'Revisions-URL',
  resume: 'Lebenslauf',
  resumeLink: 'Lebenslauf ansehen',
  rowsPerPage: 'Zeilen pro Seite',
  save: 'Speichern',
  search: 'Suchen',
  searchProjects: 'Projekte suchen',
  secondarySkill: 'Nebenfertigkeit',
  select: 'Auswählen',
  selectArtName: 'ART-Name auswählen',
  selectAUser: 'Benutzer auswählen',
  selectFilter: 'Filter auswählen',
  applyFilters: 'Filter anwenden',
  selectItemsPerPage: 'Elemente pro Seite auswählen',
  selectJiraIssues: 'Jira-Issues auswählen',
  selectPod: 'POD auswählen',
  selectPodTeamMember: 'POD-Teammitglied auswählen',
  selectPods: 'PODs auswählen',
  services: 'Dienste',
  setting: 'Einstellung',
  shareableLink: 'Teilbarer Link',
  signUpToGetStarted: '"Registrieren" Sie sich unten, um loszulegen!',
  getStarted: 'Loslegen',
  skills: 'Fähigkeiten',
  skillsAndExpertise: 'Fähigkeiten und Expertise',
  sonarqubeprojectkey: 'Sonarqube-Projektschlüssel',
  sonarqubeStats: 'Sonarqube-Statistiken',
  specialization: 'Spezialisierung',
  sprintVelocity: 'Sprint-Geschwindigkeit',
  sprint: 'Sprint',
  spotsLeft: 'Verbleibende Plätze',
  startDate: 'Startdatum',
  startDoing: 'Anfangen zu tun',
  status: 'Status',
  stopDoing: 'Aufhören zu tun',
  storyDescription: 'Story-Beschreibung',
  stories: 'Stories',
  submit: 'Senden',
  submittedDate: 'Sendedatum',
  submittedPRCount: 'Anzahl gesendeter PRs',
  subscription: 'Abonnement',
  talentApprovalRequests: 'Talent-Genehmigungsanfragen',
  talentCode: 'Talent-Code',
  taskForm: 'Aufgabenformular',
  taskManager: 'Aufgabenmanager',
  taskName: 'Aufgabenname',
  tasks: 'Aufgaben',
  teamMember: 'Teammitglied',
  techStack: 'Tech-Stack',
  termsOfService: 'Nutzungsbedingungen',
  testCases: 'Testfälle',
  time: 'Zeit',
  timeLog: 'Zeitprotokoll',
  timeSubmit: 'Zeit senden',
  timeZone: 'Zeitzone',
  toDo: 'ZU TUN',
  todaysFocus: 'Heutiger Fokus',
  totalLinesChangedLastWeek: 'Gesamte geänderte Zeilen letzte Woche',
  totalLinesChangedThisWeek: 'Gesamte geänderte Zeilen diese Woche',
  totalPRCount: 'Gesamte PR-Anzahl',
  university: 'Universität',
  update: 'Aktualisieren',
  updateProfileHere: 'Aktualisieren Sie Ihr Profil hier',
  updatingVisibility: 'Sichtbarkeit wird aktualisiert...',
  upload: 'Hochladen',
  userStory: 'User Story',
  validFrom: 'Gültig von',
  validTill: 'Gültig bis',
  talentexplorer: 'Talent-Explorer',
  interviewrequests: 'Interview-Anfragen',
  videoUrl: 'Video-URL',
  view: 'Anzeigen',
  viewActivities: 'Aktivitäten anzeigen',
  viewDetails: 'Details anzeigen',
  viewPodActivities: 'POD-Aktivitäten anzeigen',
  viewPodDetails: 'POD-Details anzeigen',
  viewProfile: 'Profil anzeigen',
  viewTasks: 'Aufgaben anzeigen',
  viewTimeEntries: 'Zeiteinträge anzeigen',
  viewVideo: 'Video anzeigen',
  visitFindTalent: 'Bitte besuchen Sie die Seite "Talente finden" und fügen Sie talentierte Personen zu Ihrem POD hinzu.',
  vulnerabilities: 'Schwachstellen',
  welcome: 'Willkommen bei Artemy.ai!',
  workExperience: 'Berufserfahrung',
  yourPod: 'Ihr POD',
  yourPods: 'Ihre PODs',
  yourPostedPodActivity: 'Ihre gepostete POD-Aktivität',
  
  findTickets: 'Tickets finden',
  epics: 'Epics',
  date: 'Datum',
  talent: 'Talent',
  focus: 'Fokus',
  startDate: 'Startdatum',
  endDate: 'Enddatum',
  status: 'Status',
  allStatus: 'Alle Status',
  blocked: 'Blockiert',
  onTrack: 'Auf Kurs',
  activityDetails: 'Aktivitätsdetails',
  jiraIssues: 'Jira-Issues',
  todaysFocus: 'Heutiger Fokus',
  accomplishments: 'Errungenschaften',
  blockers: 'Blocker',
  videoUpdate: 'Video-Update',
  comments: 'Kommentare',
  addBlockerInformation: 'Blocker-Information hinzufügen',
  blockerDetails: 'Blocker-Details',
  cancel: 'Abbrechen',
  saveChanges: 'Änderungen speichern',
  selectJiraIssues: 'Jira-Issues auswählen',
  design: 'Design',
  development: 'Entwicklung',
  testing: 'Testen',
  bugFix: 'Fehlerbehebung',
  documentation: 'Dokumentation',
  myPods: 'Meine PODs',
  postRetro: 'Retro posten',
  newRetro: 'Neue Retro',
  startDoing: 'Anfangen zu tun',
  stopDoing: 'Aufhören zu tun',
  keepDoing: 'Weitermachen',
  viewRetros: 'Retros anzeigen',
  podRetroFeedback: 'POD-Retro-Feedback',
  selectSprint: 'Sprint auswählen',
  thisTaskIsBlocker: 'Diese Aufgabe ist ein Blocker',
  category: 'Kategorie',
  taskCreatedSuccessfully: 'Aufgabe erfolgreich erstellt!',
  taskManagement: 'Aufgabenverwaltung',
  searchJiraIssues: 'JIRA-Issues suchen...',
  creatingTask: 'Aufgabe wird erstellt...',
  createTask: 'Aufgabe erstellen',
  description: 'Beschreibung',
  dueDate: 'Fälligkeitsdatum',
  commentsHistory: 'Kommentarverlauf',
  noCommentsYet: 'Noch keine Kommentare',
  writeAComment: 'Kommentar schreiben...',
  all: 'Alle',
  blockerStatus: 'Blocker-Status',
  blockedTasks: 'Blockierte Aufgaben',
  unblockedTasks: 'Nicht blockierte Aufgaben',
  clearDateRange: 'Datumsbereich löschen',
  selectDateRange: 'Datumsbereich auswählen',
  showAllTime: 'Alle Zeiten anzeigen',
  noTasksFound: 'Keine Aufgaben gefunden',
  noLinkedIssues: 'Keine verknüpften Issues',
  timeSheet: 'Zeiterfassung',
  podTimeSheet: 'POD-Zeiterfassung',
  userStory: 'User Story',
  hours: 'Stunden',
  minutes: 'Minuten',
  actions: 'Aktionen',
  submitTimeEntries: 'Zeiteinträge senden',
  selectCategory: 'Kategorie auswählen',
  selectStory: 'Story auswählen',
  addRow: 'Zeile hinzufügen',
  podSelection: 'POD-Auswahl',
  selectPodToView: 'Wählen Sie einen POD aus, um Sprint- und Talent-Filter anzuzeigen',
  toDo: 'Zu tun',
  podAssist: 'POD-Assistent',
  inProgress: 'In Bearbeitung',
  done: 'Erledigt',
  selectPodsRequired: 'PODs auswählen (Erforderlich)',
  enterStoryDescription: 'Story-Beschreibung eingeben',
  podSyncSummaries: 'POD-Sync-Zusammenfassungen',
  enterMeetingUrl: 'Meeting-URL eingeben...',
  searchInSummaries: 'In Zusammenfassungen suchen...',
  dateAndTime: 'Datum und Uhrzeit',
  quickTimeRange: 'Schneller Zeitbereich',
  sortByDate: 'Nach Datum sortieren',
  selectTalents: 'Talente auswählen',
  filterBySpecificCandidates: 'Nach bestimmten Kandidaten filtern (optional)',
  talentSelection: 'Talent-Auswahl',
  priority: 'Priorität',
  addComment: 'Kommentar hinzufügen',
  taskDetails: 'Aufgabendetails',
  summary: 'Zusammenfassung',
  addMeeting: 'Meeting hinzufügen',

  podAutomation: 'POD-Automatisierung',
  uploading: 'Wird hochgeladen...',
  uploadFile: 'Datei hochladen',
  send: 'Senden',
  submitting: 'Wird gesendet...',
  enterYourQuestionHere: 'Geben Sie Ihre Frage hier ein',
  submitTheResults: 'Ergebnisse senden',
  export: 'Exportieren',
  podInsights: 'POD-Insights',
  askQuestionsAboutYourPod: 'Stellen Sie Fragen zu Ihren POD-Aktivitäten, Teammitgliedern und mehr',
  welcomeToPodInsights: 'Willkommen bei POD-Insights!',
  startByAskingQuestionsLike: 'Beginnen Sie mit Fragen wie',
  showAllPodActivitiesThatHadBlockers: 'Alle POD-Aktivitäten anzeigen, die Blocker hatten',
  listAllCandidatesAndTheirPods: 'Alle Kandidaten und ihre PODs auflisten',
  showStakeholdersFromIndia: 'Stakeholder aus Indien anzeigen',
  askAnythingAboutYourPods: 'Fragen Sie alles über Ihre PODs, Teammitglieder, Aktivitäten...',
  sending: 'Wird gesendet...',
  analyzingYourQuestion: 'Ihre Frage wird analysiert...',
  pipelineCICD: 'Pipeline CI/CD',
  tickets: 'Tickets',
  metricName: 'Metrikname',
  metricValue: 'Metrikwert',
  commentsHistory: 'Kommentarverlauf',
  noCommentsYet: 'Noch keine Kommentare',
  writeAComment: 'Kommentar schreiben...',
  solutionManagement: 'Lösungsverwaltung',
  searchSolutions: 'Lösungen suchen...',
  refresh: 'Aktualisieren',
  createNewSolution: 'Neue Lösung erstellen',
  solutionName: 'Lösungsname',
  solutionDescription: 'Lösungsbeschreibung',
  updateSolution: 'Lösung aktualisieren',
  createSolution: 'Lösung erstellen',
  confirmSolutionDeletion: 'Sind Sie sicher, dass Sie die Lösung löschen möchten',
  artManagement: 'ART-Verwaltung',
  podManagement: 'POD-Verwaltung',
  searchPods: 'PODs suchen...',
  viewPod: 'POD anzeigen',
  searchARTs: 'ARTs suchen...',
  noARTsFound: 'Keine ARTs gefunden. Erstellen Sie Ihr erstes ART, indem Sie auf die Schaltfläche "Neues ART erstellen" klicken.',
  createNewART: 'Neues ART erstellen',
  selectGig: 'Gig auswählen',
  artName: 'ART-Name',
  artDescription: 'ART-Beschreibung',
  createART: 'ART erstellen',
  confirmDeletion: 'Löschung bestätigen',
  confirmARTDeletion: 'Sind Sie sicher, dass Sie das ART löschen möchten',
  primaryLanguage: 'Hauptsprache',
  selectSkills: 'Fähigkeiten auswählen',
  timeZone: 'Zeitzone',
  updateART: 'ART aktualisieren',
  somethingWentWrong: 'Etwas ist schief gelaufen',
  reloadPage: 'Seite neu laden',
  privatePods: 'Private PODs',
  activePods: 'Aktive PODs',
  completedPods: 'Abgeschlossene PODs',
  pendingPods: 'Ausstehende PODs',
  loadingPods: 'PODs werden geladen...',
  retry: 'Wiederholen',
  noPodsFound: 'Keine PODs gefunden',
  createFirstPod: 'Erstellen Sie Ihren ersten POD, um zu beginnen',
  previous: 'Zurück',
  showing: 'Anzeigen',
  size: 'Größe',
  teamSize: 'Teamgröße',
  activeMembers: 'Aktive Mitglieder',
  stakeholders: 'Stakeholder',
  podManagers: 'POD-Manager',
  addManager: 'Manager hinzufügen',
  podManager: 'POD-Manager',
  noManagersAssignedYet: 'Noch keine Manager zugewiesen',
  addManagersToHelpOversee: 'Fügen Sie Manager hinzu, um bei der Überwachung dieses PODs zu helfen',
  noStakeholdersYet: 'Noch keine Stakeholder',
  settings: 'Einstellungen',
  deletePod: 'POD löschen',
  addPodManager: 'POD-Manager hinzufügen',
  selectManagerToInvite: 'Wählen Sie einen Manager aus, den Sie zu diesem POD einladen möchten:',
  noManagersAvailableToInvite: 'Keine Manager zum Einladen verfügbar.',
  selectAManager: 'Manager auswählen',
  selectedManager: 'Ausgewählter Manager',
  inviteManager: 'Manager einladen',
  noTeamMembersYet: 'Noch keine Teammitglieder',
  startByInvitingMembers: 'Beginnen Sie damit, Mitglieder zu Ihrem POD einzuladen',
  inviteTeamMembers: 'Teammitglieder einladen',
  existingMembers: 'Bestehende Mitglieder',
  inviteByEmail: 'Per E-Mail einladen',
  searchByNameOrSkills: 'Nach Namen oder Fähigkeiten suchen...',
  optionalSelectUserToNotify: 'Optional: Wählen Sie einen Benutzer aus, der über Slack benachrichtigt werden soll',
  pleaseSelectPodToEnableFields: 'Bitte wählen Sie einen POD aus, um andere Felder zu aktivieren',
  selectedCandidates: 'Ausgewählte Kandidaten',
  selectCandidatesToInvite: 'Wählen Sie Kandidaten aus, die Sie zu diesem POD einladen möchten',
  availableCandidates: 'Verfügbare Kandidaten',
  inviteNewMembersByEmail: 'Neue Mitglieder per E-Mail einladen',
  emailAddresses: 'E-Mail-Adressen',
  enterEmailAddresses: 'E-Mail-Adressen eingeben (durch Kommas getrennt)',
  hidePodTeamMembers: 'Verstecken Sie die Teammitglieder dieses PODs im Bereich "PODs finden" (Derzeit sichtbar)',
  technicalDetails: 'Technische Details',
  currentTeamSize: 'Aktuelle Teamgröße',
  communicationDetails: 'Kommunikationsdetails',
  podReview: 'POD-Bewertung',
  rating: 'Bewertung',
  writeReview: 'Bewertung schreiben',
  shareYourExperience: 'Teilen Sie Ihre Erfahrung mit diesem POD...',
  submitReview: 'Bewertung senden',
  viewPod: 'POD anzeigen',
  managePod: 'POD verwalten',
  editPod: 'POD bearbeiten',
  skillsAndExperience: 'Fähigkeiten und Erfahrung',
  reviews: 'Bewertungen',
  documents: 'Dokumente',
  otherInfo: 'Weitere Informationen',
  noWorkExperienceDataAvailable: 'Keine Berufserfahrungsdaten verfügbar',
  selectART: 'ART auswählen',
  selectAnART: 'Ein ART auswählen',
  jiraConfiguration: 'Jira-Konfiguration',
  jiraProjectKey: 'Jira-Projektschlüssel',
  jiraURL: 'Jira-URL',
  jiraAdminEmail: 'Jira-Admin-E-Mail',
  jiraAdminAPIToken: 'Jira-Admin-API-Token',
  jiraOpenStoryBugStatus: 'Jira Offene Story/Bug-Status',
  jiraClosedStoryBugStatus: 'Jira Geschlossene Story/Bug-Status',
  gitHubConfiguration: 'GitHub-Konfiguration',
  gitHubUsername: 'GitHub-Benutzername',
  gitHubAPIToken: 'GitHub-API-Token',
  gitHubRepositoryName: 'GitHub-Repository-Name',
  circleCIConfiguration: 'CircleCI-Konfiguration',
  circleCIGitHubUsername: 'CircleCI GitHub-Benutzername',
  circleCIGitHubRepository: 'CircleCI GitHub-Repository',
  circleCIAPIToken: 'CircleCI-API-Token',
  sonarQubeConfiguration: 'SonarQube-Konfiguration',
  sonarQubeCloudURL: 'SonarQube Cloud-URL',
  sonarQubeAPIToken: 'SonarQube-API-Token',
  awsConfiguration: 'AWS-Konfiguration',
  awsAccessKeyID: 'AWS-Zugriffsschlüssel-ID',
  awsSecretAccessKey: 'AWS-Geheimer-Zugriffsschlüssel',
  awsRegion: 'AWS-Region',
  bitBucketConfiguration: 'BitBucket-Konfiguration',
  bitBucketUsername: 'BitBucket-Benutzername',
  bitBucketAppPassword: 'BitBucket-App-Passwort',
  bitBucketWorkspace: 'BitBucket-Arbeitsbereich',
  openAIConfiguration: 'OpenAI-Konfiguration',
  openAIToken: 'OpenAI-Token',
  storyPointsCalculation: 'Story-Points-Berechnung',
  uploadStoryPointsCalculationFile: 'Story-Points-Berechnungsdatei hochladen',
  currentFile: 'Aktuelle Datei',
  notifications: 'Benachrichtigungen',
  markAllAsRead: 'Alle als gelesen markieren',
  tryAgain: 'Erneut versuchen',
  noNotificationsToDisplay: 'Keine Benachrichtigungen anzuzeigen',
  viewAllNotifications: 'Alle Benachrichtigungen anzeigen',
  enterMultipleEmailsSeparatedByCommas: 'Mehrere E-Mails durch Kommas getrennt eingeben',
  addEmailAddressesToInvite: 'E-Mail-Adressen hinzufügen, um neue Mitglieder einzuladen',
  emailInvitationGuidelines: 'E-Mail-Einladungsrichtlinien',
  inviteesWillReceiveInstructions: 'Eingeladene erhalten Anweisungen, um diesem POD beizutreten',
  theyWillNeedToCreateAccount: 'Sie müssen ein Konto erstellen, falls sie noch keines haben',
  noCandidatesAvailable: 'Keine Kandidaten verfügbar',
  sendEmailInvites: 'E-Mail-Einladungen senden',

  processingDataAndGeneratingInsights: 'Daten werden verarbeitet und Erkenntnisse generiert',
  retroHistory: 'Retro-Verlauf',
  filterByMember: 'Nach Mitglied filtern',
  podProductivity: 'POD-Produktivität',
  totalTasks: 'Gesamte Aufgaben',
  completed: 'Abgeschlossen',
  clearFilters: 'Filter löschen',
  totalActivities: 'Gesamte Aktivitäten',
  pendingApproval: 'Genehmigung ausstehend',
  sortBy: 'Sortieren nach',
  editSolution: 'Lösung bearbeiten',
  cannotDeleteAssociatedWithARTs: 'Kann nicht gelöscht werden - mit ARTs verknüpft',
  editART: 'ART bearbeiten',
  createdDate: 'Erstellungsdatum',
  podDetails: 'POD-Details',
  currentARTProject: 'Aktuelles ART/Projekt',
  artProject: 'ART/Projekt',
  selectAvailability: 'Verfügbarkeit auswählen',
  selectSkill: 'Fähigkeit auswählen',
  selectTimezone: 'Zeitzone auswählen',
  selectLocation: 'Standort auswählen',
  selectBudget: 'Budget auswählen',
  podMember: 'POD-Mitglied',
  addToPod: 'Zu POD hinzufügen',
  talentDetails: 'Talent-Details',
  reviewsFeedback: 'Bewertungen und Feedback',
  noEducationDataAvailable: 'Keine Bildungsdaten verfügbar',
  noCertificationDataAvailable: 'Keine Zertifizierungsdaten verfügbar',
  clientReview: 'Kundenbewertung',
  noReviewsAvailableYet: 'Noch keine Bewertungen verfügbar',
  noClientReviews: 'Dieses Talent hat bisher keine Kundenbewertungen erhalten',
  resumeAvailable: 'Lebenslauf verfügbar',
  viewDownloadResume: 'Lebenslauf des Kandidaten anzeigen oder herunterladen',
  noResumeAvailable: 'Kein Lebenslauf verfügbar',
  noResumeUploaded: 'Dieses Talent hat keinen Lebenslauf hochgeladen.',
  codingAssessment: 'Programmier-Assessment',
  assessmentAvailable: 'Assessment verfügbar',
  viewAssessmentResults: 'Programmier-Assessment-Ergebnisse des Kandidaten anzeigen',
  noAssessmentAvailable: 'Kein Assessment verfügbar',
  noAssessmentCompleted: 'Dieses Talent hat kein Programmier-Assessment abgeschlossen.',
  partnerCompanyDetails: 'Partner-Unternehmensdetails',
  companyIntroductionVideo: 'Unternehmensvorstellungsvideo',
  videoNotSupported: 'Ihr Browser unterstützt das Video-Tag nicht.',
  location: 'Standort',
  noPodsMatchingCriteria: 'Keine PODs gefunden, die Ihren Kriterien entsprechen',
  hirePod: 'POD beauftragen',
  notificationHistory: 'Benachrichtigungsverlauf',
  filter: 'Filter',
  allNotifications: 'Alle Benachrichtigungen',
  markSelected: 'Ausgewählte markieren',
  unread: 'Ungelesen',
  noNotificationsFound: 'Keine Benachrichtigungen gefunden',
  searchNotifications: 'Benachrichtigungen durchsuchen...',
  subscriptionManagement: 'Abonnement-Verwaltung',
  choosePlanPrompt: 'Wählen Sie einen Plan, der am besten zu Ihren Bedürfnissen passt und mit Ihrem Wachstum skaliert',
  cancelSubscription: 'Abonnement Kündigen',
  choosePlan: 'Plan Wählen',
  noPlansAvailable: 'Keine Pläne Verfügbar',
  noPlansHelpText: 'Bitte schauen Sie später wieder vorbei oder kontaktieren Sie den Support für Hilfe.',
  currentPlanDetails: 'Aktuelle Plan-Details',
  renewalDate: 'Verlängerungsdatum',
  subscriptionId: 'Abonnement-ID',
  paymentMethod: 'Zahlungsmethode',
  cardHolder: 'Karteninhaber',
  expires: 'Läuft ab',
  brand: 'Marke',
  billingHistory: 'Abrechnungshistorie',
  noInvoiceHistory: 'Keine Rechnungshistorie verfügbar',
  needHelp: 'Benötigen Sie Hilfe?',
  supportText: 'Wenn Sie Fragen zu unseren Abonnement-Plänen haben oder Hilfe benötigen, ist unser Support-Team hier, um Ihnen zu helfen.',
  contactSupport: 'Support Kontaktieren',
  completeSubscription: 'Vervollständigen Sie Ihr Abonnement',
  planDetails: 'Plan-Details',
  planName: 'Plan-Name',
  basePrice: 'Grundpreis',
  numberOfUsers: 'Anzahl der Benutzer',
  billingCycle: 'Abrechnungszyklus',
  orderSummary: 'Bestellübersicht',
  annualDiscount: 'Jahresrabatt',
  billingPeriod: 'Abrechnungszeitraum',
  tax: 'Steuer',
  totalWithTax: 'Gesamt mit Steuern',
  annually: 'jährlich',
  continue: 'Fortfahren',
  subscriptionSuccessful: 'Abonnement Erfolgreich!',
  thankYouSubscribing: 'Vielen Dank für Ihr Abonnement von',
  subscriptionActivated: 'Ihr Abonnement wurde erfolgreich aktiviert.',
  goToDashboard: 'Zum Dashboard',
  addPaymentMethod: 'Zahlungsmethode Hinzufügen',
  cardNumber: 'Kartennummer',
  cardholderName: 'Name des Karteninhabers',
  expiryMonth: 'Ablaufmonat',
  expiryYear: 'Ablaufjahr',
  postalCode: 'Postleitzahl',
  addCard: 'Karte Hinzufügen',
  paymentChoice: 'Vorhandene Karte Verwenden oder Neue Karte Hinzufügen',
  existingCardText: 'Sie haben bereits eine vorhandene Karte, die endet mit',
  useExistingCardPrompt: 'Möchten Sie sie für dieses Abonnement verwenden?',
  useExistingCard: 'Vorhandene Karte Verwenden',
  addNewCard: 'Neue Karte Hinzufügen',
  processing: 'Wird verarbeitet...',
  subscriptionSuccessDetails: 'war erfolgreich!',
  accessAllFeatures: 'Sie können jetzt auf alle Funktionen zugreifen, die in Ihrem Abonnement-Plan enthalten sind.',
  editCardDetails: 'Kartendetails Bearbeiten',
  managerInvite: 'Manager-Einladung',
  talentInvite: 'Talent-Einladung',
  invitePodManagers: 'E-Mail eingeben, um Pod-Manager einzuladen',
  enterEmail: 'E-Mail eingeben',
  invite: 'Einladen',
  yourInvoices: 'Ihre Rechnungen',
  noInvoices: 'Sie haben keine Rechnungen.',
  amountDue: 'Fälliger Betrag',
  amountPaid: 'Bezahlter Betrag',
  getCountIsseswithNoCritria: 'Anzahl der Issues ohne Akzeptanzkriterien abrufen',
  noActiveSubscription: 'Sie haben keinen aktiven Abonnement-Plan. Bitte klicken Sie auf den "Abonnieren"-Link, um ein Abonnement hinzuzufügen.',
 noActiveSubscriptionStart: 'Sie haben keinen aktiven Abonnement-Plan. Bitte klicken Sie auf den',
  subscribe: 'Abonnieren',
  noActiveSubscriptionEnd: 'Link, um ein Abonnement hinzuzufügen.'};
export default messagesDe;